import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  EventTypeIcon,
  TYPE_LABELS,
} from "features/combinedInputsOutputs/RecordsPage";
import UpdateFertilizerEvent from "features/fertilizerInput/UpdateFertilizerEvent";
import UpdateFieldPreparationEvent from "features/fieldPreparationInput/UpdateFieldPreparationEvent";
import UpdateReseedEvent from "features/singleReseedEventInput/UpdateReseedEvent";
import UpdateYieldEvent from "features/yieldInput/UpdateYieldEvent";
import { useFieldsByIds } from "model";
import { useState } from "react";
import { useAppStore } from "stores";
import { getFormattedTime } from "../../common/utils/getFormattedTime";
import type { FieldIngestedEvent } from "./FieldEventList";

export default function IngestedFieldEventListItem({
  item,
}: {
  item: FieldIngestedEvent;
}) {
  const locale = useAppStore((state) => state.locale);
  const formattedDate = getFormattedTime(item.date, locale);
  const note = item.event.note;
  const [editOpen, setEditOpen] = useState(false);

  const { data: reseedFields = [] } = useFieldsByIds(
    item.type === "seeding" ? item.event.fieldGuids : undefined
  );

  return (
    <>
      <ListItemButton
        key={`ie-listitem-${item.guid}`}
        onClick={() => setEditOpen(true)}
      >
        <ListItemIcon>
          <EventTypeIcon type={item.type} />
        </ListItemIcon>
        <ListItemText
          primary={TYPE_LABELS[item.type]}
          secondary={
            <>
              <Typography component="span" display="block">
                {formattedDate}
              </Typography>
              {note && (
                <Typography component="span" display="block" noWrap>
                  {note}
                </Typography>
              )}
            </>
          }
        />
      </ListItemButton>
      {item.type === "seeding" && (
        <UpdateReseedEvent
          reseedEvent={item.event}
          fields={reseedFields}
          dialogOpen={editOpen}
          setDialogOpen={setEditOpen}
        />
      )}
      {item.type === "fertiliser" && (
        <UpdateFertilizerEvent
          fertilizerEvent={item.event}
          dialogOpen={editOpen}
          setDialogOpen={setEditOpen}
        />
      )}
      {item.type === "harvest" && (
        <UpdateYieldEvent
          yieldEvent={item.event}
          dialogOpen={editOpen}
          setDialogOpen={setEditOpen}
        />
      )}
      {item.type === "fieldPrep" && (
        <UpdateFieldPreparationEvent
          fieldPreparationEvent={item.event}
          dialogOpen={editOpen}
          setDialogOpen={setEditOpen}
        />
      )}
    </>
  );
}
